import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "space-y-3 p-3 animate__animated animate__fadeIn"
}
const _hoisted_2 = { class: "flex flex-row w-full mb-2 justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-extralight" }, /*#__PURE__*/_toDisplayString("Code Challenge"), -1)
const _hoisted_4 = {
  key: 0,
  class: "px-3 mb-6 md:mb-0"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "block tracking-wide text-gray-700 text-xs font-semibold mb-2",
  for: "challenge-status"
}, " Change status ", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "pending" }, "Pending", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "started" }, "Started", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "over" }, "Finished", -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "font-light text-lg pt-3"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" The code challenge has been sent. ")
const _hoisted_13 = { class: "flex flex-row space-x-3 mt-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#8C92AC"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4.8 12l4.6 4.6L8 18l-6-6 6-6 1.4 1.4L4.8 12zm14.4 0l-4.6 4.6L16 18l6-6-6-6-1.4 1.4 4.6 4.6z" })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Test:", -1)
const _hoisted_16 = { class: "flex flex-row space-x-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "#8C92AC",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M13 10V3L4 14h7v7l9-11h-7z"
  })
], -1)
const _hoisted_18 = { class: "capitalize" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Status: ", -1)
const _hoisted_20 = { class: "flex flex-row space-x-3 items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 text-primary",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "#8C92AC",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
  })
], -1)
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "flex flex-row w-full justify-end space-x-3" }
const _hoisted_24 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.isSent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("select", {
                  name: "job_challenge_status",
                  class: "bg-gray-100 py-2 px-4 rounded",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateChallengStatus($event, _ctx.data))),
                  value: _ctx.data?.challenge_status
                }, _hoisted_10, 40, _hoisted_6)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isSent)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", null, [
                  _hoisted_15,
                  _createTextVNode(" " + _toDisplayString(_ctx.data?.job_challenge_title), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("span", _hoisted_18, [
                  _hoisted_19,
                  _createTextVNode(" " + _toDisplayString(_ctx.data?.challenge_status), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("a", {
                  href: _ctx.data?.results_url,
                  target: "blank",
                  class: "hover:underline text-primary"
                }, "Challenge URL", 8, _hoisted_22)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          (_ctx.status !== 'over')
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_component_Button, {
                  label: _ctx.isSent ? 'Resend challenge' : 'Send challenge',
                  type: "button",
                  variant: "contained",
                  disabled: _ctx.validStatus?.includes(_ctx.status) || _ctx.isLoadingButton,
                  onOnClick: _ctx.sendChallenge
                }, null, 8, ["label", "disabled", "onOnClick"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
}